<template>
    <a-popup :visible="visible" @cancel="onCancel">
        <div class="tw-mx-auto tw-w-[95%] md:tw-max-w-[500px] tw-bg-white tw-rounded-2xl tw-shadow-lg tw-overflow-hidden">
            <!-- Header -->
            <div class="tw-p-6 tw-text-center">
                <div class="tw-w-16 tw-h-16 tw-bg-rose-50 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
                    <icon icon="solar:danger-triangle-bold-duotone" class="tw-text-2xl tw-text-rose-500" />
                </div>
                <h2 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-2">
                    {{ title || $t('messages.are-you-sure-you-want-to-delete') }}
                </h2>
                <p class="tw-text-sm tw-text-gray-600">
                    {{ description || $t('messages.action-cannot-be-reverted') }}
                </p>
            </div>

            <!-- Footer -->
            <div class="tw-p-6 tw-bg-gray-50 tw-flex tw-items-center tw-justify-end tw-gap-3">
                <a-button 
                    intent="white" 
                    :disabled="props.loading" 
                    @click="onCancel"
                    class="tw-min-w-[100px]"
                >
                    {{ $t('buttons.no-cancel') }}
                </a-button>
                <a-button 
                    intent="danger" 
                    :disabled="props.loading" 
                    :loading="props.loading" 
                    @click="onConfirm" 
                    class="tw-min-w-[160px]"
                >
                    {{ $t('buttons.delete') }}
                </a-button>
            </div>
        </div>
    </a-popup>
</template>

<script setup>
import { defineEmits, defineProps, toRef } from 'vue';

const props = defineProps({
    visible: Boolean,
    loading: Boolean,
    title: String,
    description: String
});

const emit = defineEmits(['confirm', 'cancel']);
const visible = toRef(props, 'visible');

const onConfirm = () => {
    emit('confirm');
}

const onCancel = () => {
    if(!props.loading) {
        emit('cancel');
    }
}

</script>

<style scoped>
/* Minimal focus states */
button:focus-visible,
a-button:focus-visible {
    @apply tw-outline-none tw-ring-2 tw-ring-primary-500 tw-ring-offset-2;
}
</style>